import { Button, Div, H2, Hr, P, Space } from '@dnb/eufemia';
import type { JSX } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Card from '@/components/Card';
import Container from '@/components/Container';
import ModalPage from '@/components/ModalPage';

import style from './index.module.css';

import clapIllustrationUrl from '@/illustrations/clap.svg?url';

type SuccessModalProps = {
  teamId: string;
  appId: string;
  mcpId: string;
  mcpSlug: string;
};

export default function SuccessModal({ teamId, appId, mcpId, mcpSlug }: SuccessModalProps): JSX.Element {
  return (
    <ModalPage hideCloseButton>
      <Container centered size="small">
        <Card className={style['Card']}>
          <H2 bottom={0} className={style['success-text']}>
            Yay!
          </H2>
          <H2 bottom={0}>MCP created</H2>
          <Space bottom="medium">
            <img alt="Hands clapping" src={clapIllustrationUrl} />
          </Space>
          <P bottom="medium" size="small">
            MCP has been created. Next, go to visibility settings to make it available to all of DNB or specific teams.
          </P>
          <Div>
            <Button
              element={RouterLink}
              icon="chevron_right"
              iconPosition="right"
              size="large"
              to={`/team/${teamId}/application/${appId}/api/${mcpId}/visibility-access`}
              variant="secondary"
            >
              Go to visibility settings
            </Button>
            <Hr bottom="small" top="small" />
            <Button
              element={RouterLink}
              size="small"
              text="View MCP"
              to={`/mcp-servers/${mcpSlug}/@default/@latest/guide`}
              variant="tertiary"
            />
          </Div>
        </Card>
      </Container>
    </ModalPage>
  );
}
